import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Register from "./pages/authentication/Register";
import {ScopedCssBaseline, ThemeProvider} from "@mui/material";
import Verification from "./pages/authentication/Verification";
import {appTheme} from "./themes/AppTheme";
import RateReview from "./pages/review/RateReview";
import Private from "./pages/Private";
import PropertyRateReview from "./pages/review/PropertyRateReview";
import LoginPage from "./pages/home/LoginPage";

function App() {
    return (
        <ThemeProvider theme={appTheme}>
            <ScopedCssBaseline>
                <Router>
                    <Routes>
                        <Route
                            exact={true}
                            path={"/*"}
                            element={<LoginPage/>}/>
                        <Route
                            exact={true}
                            path={"/verification"}
                            element={<Verification/>}/>
                        <Route
                            exact={true}
                            path={"/register"}
                            element={<Register/>}/>
                        <Route
                            path={"/private/*"}
                            element={<Private/>}/>
                        <Route
                            path={"/rate-review/:trackId"}
                            element={<RateReview/>}/>
                        <Route
                            path={"/property-rate-review/:propertyId"}
                            element={<PropertyRateReview/>}/>
                    </Routes>
                </Router>
            </ScopedCssBaseline>
        </ThemeProvider>
    );
}

export default App;
